import { ActionType } from 'typesafe-actions'

import { foodsActionType, foodsActions } from './actions'
import { Food, FoodImage } from './foods'

export interface FoodsState {
  readonly error: Error
  readonly isLoading: boolean
  readonly foods: Food[]
  readonly currentFood: Food | null
  readonly foodImage: FoodImage
  readonly active: 'foods' | 'food' | 'none'
  readonly currentBrandCode: string | null
}

export const initialState: FoodsState = {
  error: null,
  isLoading: false,
  foods: [],
  currentFood: null,
  foodImage: null,
  active: 'none',
  currentBrandCode: null,
}

export const foodsReducer = (
  state: FoodsState = initialState,
  action: ActionType<typeof foodsActions>
) => {
  switch (action.type) {
    case foodsActionType.FETCH_FOODS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodsActionType.FETCH_FOODS_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
        foods: action.payload.foods,
      }
    case foodsActionType.FETCH_FOOD:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodsActionType.FETCH_FOOD_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
        currentFood: action.payload.food,
      }
    case foodsActionType.FETCH_FOODS_EVERY:
      return {
        ...state,
        error: null,
        active: 'foods',
      }
    case foodsActionType.FETCH_FOODS_EVERY_FINISHED:
      return {
        ...state,
        error: null,
        active: 'none',
      }
    case foodsActionType.SET_FOOD:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodsActionType.SET_FOOD_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    case foodsActionType.UPLOAD_FOOD_IMAGE:
      return {
        ...state,
        foodImage: null,
        isLoading: true,
        error: null,
      }
    case foodsActionType.SET_FOOD_IMAGE_URL:
      return {
        ...state,
        foodImage: {
          fileName: action.payload.fileName,
          url: action.payload.url,
          foodImageType: action.payload.foodImageType,
        },
        error: null,
      }
    case foodsActionType.CREATE_FOOD:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodsActionType.CREATE_FOOD_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
      }
    case foodsActionType.CHANGE_FOODS_INDEX:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case foodsActionType.SET_CURRENT_BRAND_CODE:
      return {
        ...state,
        currentBrandCode: action.payload.brandCode,
      }
    case foodsActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}
